import { DEFAULT_WALL_COLOR } from "@gettactic/map-builder/src/components/map/defines";
import type { WallShape } from "@gettactic/map-builder/src/types";
import { getWallDash } from "@gettactic/map-builder/src/utils/wall";
import React from "react";
import { WallEdge } from "./wallEdge";

export interface WallSvgProps {
  shape: WallShape;
}

export const WallSvg: React.FC<WallSvgProps> = ({ shape }) => {
  const color = shape.color || DEFAULT_WALL_COLOR;
  const dashArray = getWallDash(shape.dashPattern, shape.thickness)?.join(",");
  return (
    <g>
      <WallEdge
        from={{ x: shape.x, y: shape.y }}
        to={{ x: shape.x2, y: shape.y2 }}
        thickness={shape.thickness}
        color={color}
        dashArray={dashArray}
        curvature={shape.curvature || 0}
        curvatureCenter={shape.curvatureCenter ?? 0.5}
        doors={shape.doors}
        windows={shape.windows}
      />
      {(shape.lineCapStart || "butt") === "round" && (
        <circle
          cx={shape.x}
          cy={shape.y}
          r={shape.thickness / 2}
          fill={color}
        />
      )}
      {(shape.lineCapEnd || "butt") === "round" && (
        <circle
          cx={shape.x2}
          cy={shape.y2}
          r={shape.thickness / 2}
          fill={color}
        />
      )}
    </g>
  );
};
